import Link from 'next/link';
import { ProductAggregateDocument } from '@/types/manage.types';

interface ProductInfoProps {
  product: ProductAggregateDocument;
}

export function ProductInfo({ product }: ProductInfoProps) {
  return (
    <Link href={`/menu-item/${product.slug}`}>
      <h3 className="text-xl font-semibold text-orange-600 mb-2">{product.name}</h3>
      <p className="text-base text-gray-600">{product.description}</p>
    </Link>
  );
}
